import React,{useCallback, useEffect, useState} from 'react'
import { toast } from 'react-toastify';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { useAddCustomerMutation } from '../../backoffice/apis/customerAPI';
import { confirmAlert } from 'react-confirm-alert';
import { Customer, getEmptyCustomer, validateCustomer } from '../../backoffice/dtos/customer/customer';
import { useTranslation } from 'react-i18next';
import { getMessageFromRtkError } from '../../backoffice/apis/baseAPI';

const CustomerEditModal = (
    {
        isOpen,
        toggle,
        selectedCustomer,
    }:{
        isOpen: boolean;
        toggle: () => void;
        selectedCustomer ?: Customer;
    }
) => {

    const {t} = useTranslation(['customers','common'])
    const [ addCustomer ] = useAddCustomerMutation()
    const [formErrors, setFormErrors] = useState<Partial<Customer>>({})
    const [customer, setCustomer] = useState<Customer>(getEmptyCustomer())

    useEffect(() => {
        setCustomer(selectedCustomer ?? getEmptyCustomer())
    }, [selectedCustomer])

    const updateCustomer = useCallback(async () => {
        try {
            await addCustomer(customer).unwrap();
            if (selectedCustomer) {
                toast(t('successful_update_alert'))
            } else {
                toast(t('Customer added successfuly!'))
            }
            toggle()
        } catch (e:any) {
            toast(getMessageFromRtkError(e))
        }
    }, [customer, selectedCustomer])

    const handleUpdate = useCallback(async () => {
        const errors = validateCustomer(customer)
        setFormErrors(errors);

        if (Object.entries(errors).length === 0) {
            await updateCustomer()
        }
    }, [updateCustomer, customer])

    const confirmUpdate = useCallback(() => {

        if (selectedCustomer?.id != null) {
            confirmAlert({
                title: t('Update customer'),
                message: t("Are you certain for the customer's update?",{customer: customer.shortDescription}),
                buttons: [{ label: t('yes',{ns:'common'}), onClick: handleUpdate}, { label: t('no',{ns:'common'}) }]
            })
        } else {
            confirmAlert({
                title: t('Create customer'),
                message: t("Are you certain for the customer's creation?"),
                buttons: [{ label: t('yes',{ns:'common'}), onClick: handleUpdate}, { label: t('no',{ns:'common'}) }]
            })
        }
    }, [handleUpdate, customer])

    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggle}>
                {
                    customer?.id ? (
                        <ModalHeader toggle={toggle}>{t('edit', { ns: 'common' })}</ModalHeader>
                    ) : (

                        <ModalHeader toggle={toggle}>{t('create', { ns: 'common' })}</ModalHeader>
                    )
                }
                {
                    customer !== undefined || null ?
                        <ModalBody>
                            <Label>{t('Name', { ns: 'common' })}</Label>
                            <Input
                                placeholder={customer? customer.description : undefined}
                                value={customer? customer.description : undefined}
                                onChange={(e) => setCustomer({...customer, description: e.target.value})}
                            />
                            <p style={{color:'red'}}>{formErrors.description}</p>
                            <Label>{t('Short Name', { ns: 'common' })}</Label>
                            <Input type="text"
                                placeholder={customer? customer.shortDescription : undefined}
                                value={customer? customer.shortDescription : undefined}
                                onChange={(e) => setCustomer({...customer, shortDescription: e.target.value})}
                            />
                            <p style={{color:'red'}}>{formErrors.shortDescription}</p>

                            <Label>Payer Code:</Label>
                            <Input
                                placeholder={customer? customer.payerOfAccountCode : undefined}
                                value={customer? customer.payerOfAccountCode : undefined}
                                onChange={(e) => setCustomer({...customer, payerOfAccountCode: e.target.value})}
                            />
                            <p style={{color:'red'}}>{formErrors.payerOfAccountCode}</p>
                            <Label>Vendor Code</Label>
                            <Input type="text"
                                placeholder={customer? customer.vendorCode : undefined}
                                value={customer? customer.vendorCode : undefined}
                                onChange={(e) => setCustomer({...customer, vendorCode: e.target.value})}
                            />
                            <p style={{color:'red'}}>{formErrors.vendorCode}</p>
                            <Label>Order Number</Label>
                            <Input type="text"
                                placeholder={customer? customer.orderNumber : undefined}
                                value={customer? customer.orderNumber : undefined}
                                onChange={(e) => setCustomer({...customer, orderNumber: e.target.value})}
                            />
                            <p style={{color:'red'}}>{formErrors.vendorCode}</p>

                        </ModalBody>
                        :<Spinner></Spinner>
                }

                <ModalFooter>
                    <Button color="success" onClick={confirmUpdate}>
                        {t('update',{ns:'common'})}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default CustomerEditModal
